import React from "react";
import  'bootstrap/dist/css/bootstrap.min.css' ;
import { Container } from "react-bootstrap";
import Painel from "./pages/Painel/index.js";

import "./App.css";

import Routes from "./routes";

function App() {
  return (
    <main>
      <Painel />
      <Container>
        <Routes />
      </Container>
    </main>
  );
}

export default App;
